import { useQuery } from 'react-query';

import api from '../../utils/api';
import { FETCH_TAGS } from '../../constants/endpoints';

// queries
const fetchTags = () => api.get(FETCH_TAGS);
export const useFetchTags = () => useQuery([FETCH_TAGS], fetchTags);



// WEBPACK FOOTER //
// ./src/hooks/react-query/useTagData.js